import { Field } from "formik";
import React from "react";

const Select = ({ field, errors, touched, isDisabled = false }) => {
  return (
    <>
      <Field
        disabled={isDisabled}
        as="select"
        name={`${field.id}`}
        className={errors[`${field.id}`] && touched[`${field.id}`] ? "input-error" : ""}
      >
        <option value="">Selecione</option>
        {field.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Field>

      <button type="button" className={`arrow-select ${isDisabled ? "disabled" : ""}`}>
        <svg width="17" height="11" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.15791 0.248932L0.294273 8.98339C0.106364 9.16973 8.43111e-08 9.42982 8.10243e-08 9.70544L1.15861e-08 15.5284C7.02628e-09 15.9108 0.205636 16.2582 0.524727 16.4154C0.845591 16.5707 1.21964 16.5067 1.47845 16.2505L9.75 8.10024L18.0198 16.2505C18.2804 16.5067 18.6544 16.5727 18.9735 16.4154C19.2944 16.2582 19.5 15.9108 19.5 15.5284L19.5 9.70544C19.5 9.42982 19.3919 9.16973 19.2075 8.98339L10.3439 0.248932C10.007 -0.0829772 9.49295 -0.0829772 9.15791 0.248932Z"
            fill="white"
          />
        </svg>
      </button>
    </>
  );
};

export default Select;
